import {RouterProvider, createRouter} from "@tanstack/react-router";
import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {routeTree} from "./routeTree.gen";

import "@/shared/lib/global.css";
import * as Sentry from "@sentry/react";

const router = createRouter({routeTree, defaultStructuralSharing: true});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

Sentry.init({
	enabled: process.env.NODE_ENV !== "development",
	debug: process.env.NODE_ENV === "development",
	dsn: "https://dc0844c6c720d9bad0706650cb37a9b1@o4508721555177472.ingest.us.sentry.io/4508897804484608",
	integrations: [
		// Sentry.captureConsoleIntegration({levels: ["info", "log", "warn", "error"]}),
		Sentry.browserTracingIntegration(),
		Sentry.browserProfilingIntegration(),
		Sentry.tanstackRouterBrowserTracingIntegration(router),
		Sentry.replayIntegration({
			maskAllText: false, // 리플레이 텍스트 마스킹 off
			blockAllMedia: false // 리플레이 미디어 block off
		})
	],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ["localhost", /^https:\/\/tarms-api.teamshareskorea.co.kr/],
	// Session Replay
	replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// biome-ignore lint/style/noNonNullAssertion: <explanation>
const container = document.getElementById("app")!;
const root = createRoot(container, {
	// Callback called when an error is thrown and not caught by an ErrorBoundary.
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn("Uncaught error", error, errorInfo.componentStack);
	}),
	// Callback called when React catches an error in an ErrorBoundary.
	onCaughtError: Sentry.reactErrorHandler(),
	// Callback called when React automatically recovers from errors.
	onRecoverableError: Sentry.reactErrorHandler()
});
root.render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>
);
